function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BoundaryNodeRule = /*#__PURE__*/function () {
  function BoundaryNodeRule() {
    _classCallCheck(this, BoundaryNodeRule);
    BoundaryNodeRule.constructor_.apply(this, arguments);
  }
  return _createClass(BoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {}
  }, {
    key: "getClass",
    value: function getClass() {
      return BoundaryNodeRule;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { BoundaryNodeRule as default };
var Mod2BoundaryNodeRule = /*#__PURE__*/function () {
  function Mod2BoundaryNodeRule() {
    _classCallCheck(this, Mod2BoundaryNodeRule);
    Mod2BoundaryNodeRule.constructor_.apply(this, arguments);
  }
  return _createClass(Mod2BoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount % 2 === 1;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Mod2BoundaryNodeRule;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
}();
Mod2BoundaryNodeRule.constructor_ = function () {};
var EndPointBoundaryNodeRule = /*#__PURE__*/function () {
  function EndPointBoundaryNodeRule() {
    _classCallCheck(this, EndPointBoundaryNodeRule);
    EndPointBoundaryNodeRule.constructor_.apply(this, arguments);
  }
  return _createClass(EndPointBoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount > 0;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EndPointBoundaryNodeRule;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
}();
EndPointBoundaryNodeRule.constructor_ = function () {};
var MultiValentEndPointBoundaryNodeRule = /*#__PURE__*/function () {
  function MultiValentEndPointBoundaryNodeRule() {
    _classCallCheck(this, MultiValentEndPointBoundaryNodeRule);
    MultiValentEndPointBoundaryNodeRule.constructor_.apply(this, arguments);
  }
  return _createClass(MultiValentEndPointBoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount > 1;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MultiValentEndPointBoundaryNodeRule;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
}();
MultiValentEndPointBoundaryNodeRule.constructor_ = function () {};
var MonoValentEndPointBoundaryNodeRule = /*#__PURE__*/function () {
  function MonoValentEndPointBoundaryNodeRule() {
    _classCallCheck(this, MonoValentEndPointBoundaryNodeRule);
    MonoValentEndPointBoundaryNodeRule.constructor_.apply(this, arguments);
  }
  return _createClass(MonoValentEndPointBoundaryNodeRule, [{
    key: "isInBoundary",
    value: function isInBoundary(boundaryCount) {
      return boundaryCount === 1;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MonoValentEndPointBoundaryNodeRule;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [BoundaryNodeRule];
    }
  }]);
}();
MonoValentEndPointBoundaryNodeRule.constructor_ = function () {};
BoundaryNodeRule.Mod2BoundaryNodeRule = Mod2BoundaryNodeRule;
BoundaryNodeRule.EndPointBoundaryNodeRule = EndPointBoundaryNodeRule;
BoundaryNodeRule.MultiValentEndPointBoundaryNodeRule = MultiValentEndPointBoundaryNodeRule;
BoundaryNodeRule.MonoValentEndPointBoundaryNodeRule = MonoValentEndPointBoundaryNodeRule;
BoundaryNodeRule.constructor_ = function () {};
BoundaryNodeRule.MOD2_BOUNDARY_RULE = new Mod2BoundaryNodeRule();
BoundaryNodeRule.ENDPOINT_BOUNDARY_RULE = new EndPointBoundaryNodeRule();
BoundaryNodeRule.MULTIVALENT_ENDPOINT_BOUNDARY_RULE = new MultiValentEndPointBoundaryNodeRule();
BoundaryNodeRule.MONOVALENT_ENDPOINT_BOUNDARY_RULE = new MonoValentEndPointBoundaryNodeRule();
BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE = BoundaryNodeRule.MOD2_BOUNDARY_RULE;